import { render } from "./product-matching-set.vue?vue&type=template&id=aad4c9dc"
import script from "./product-matching-set.vue?vue&type=script&lang=js"
export * from "./product-matching-set.vue?vue&type=script&lang=js"

import "./product-matching-set.vue?vue&type=style&index=0&id=aad4c9dc&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__